import React, { useState } from 'react';
import { ChevronDown, ChevronUp, FlaskConical } from 'lucide-react';

type RecipeItem = {
  id: number;
  name: string;
  ingredients: string[];
  method: string;
  homemadeNote: string;
  author: string;
};

const recipes: RecipeItem[] = [
  {
    id: 1,
    name: '布朗尼',
    ingredients: [
      'Blended Whisky 25ml',
      'Fair Ginger Liqueur 10ml',
      '元酒Yuan 7ml',
      'Sandeman Ruby Port Wine 7ml',
      'Brownie Cake 1片',
      'Tamarind Paste 14mg',
    ],
    method: 'stir',
    homemadeNote: '-',
    author: '潇潇',
  },
  {
    id: 2,
    name: 'Yuan Mule（日本米其林一星酒单）',
    ingredients: ['元酒2021 50ml', '咸话梅蜂蜜 20ml', '青柠汁 15ml', '干姜水 60ml'],
    method: 'build',
    homemadeNote:
      '咸话梅蜂蜜：35颗咸话梅、350ml纯净水、50g蜂蜜小火边搅拌边煮，煮沸后再继续煮3分钟关火，自然放凉后咖啡滤纸过滤装瓶，冷藏保存',
    author: 'asher',
  },
  {
    id: 3,
    name: '轻舟',
    ingredients: ['元酒2021 30ml', '圣哲曼或菲奥伦特接骨木花利口酒 27ml', '伏特加 30ml'],
    method: 'stir',
    homemadeNote: '-',
    author: '光',
  },
  {
    id: 4,
    name: 'Yuan Gelato',
    ingredients: ['元酒2021 45ml', '白兰地 10ml', '榛子利口酒 25ml', '牛奶 25ml', '奶油 20ml'],
    method: 'shake',
    homemadeNote: '-',
    author: 'Nicole',
  },
  {
    id: 5,
    name: '元白',
    ingredients: ['元酒2021 50ml', '莉莱白 30ml', '香博 10ml'],
    method: 'rolling',
    homemadeNote: '-',
    author: '淼淼',
  },
  {
    id: 6,
    name: '兔子洞',
    ingredients: ['元酒2021 60ml', '红味美思（建议草本风味）25ml', '廊酒 15ml'],
    method: 'stir',
    homemadeNote: '-',
    author: '祁老师',
  },
  {
    id: 7,
    name: '紫气东来（2025年CMBC冠军配方）',
    ingredients: ['金酒 45ml', '巨峰葡萄汁 30ml', '元酒2021 20ml', '桂花糖浆 15ml', '柠檬汁 20ml'],
    method: 'shake',
    homemadeNote: '-',
    author: '淼淼',
  },
  {
    id: 8,
    name: '夜班飞机',
    ingredients: ['金酒 45ml', '伏特加 30ml', '元酒2021 20ml', '紫罗兰利口酒 10ml', '橙味苦精 2 dash'],
    method: 'stir',
    homemadeNote: '-',
    author: '杨博',
  },
  {
    id: 9,
    name: '光',
    ingredients: ['元酒2021 60ml', '柠檬汁 15ml', '糖 10ml', '普洛赛克起泡酒 适量top'],
    method: 'shake & build',
    homemadeNote: '起泡酒在 shake 完装杯后再补充，放一块摇冰以保持温度',
    author: '淼淼',
  },
  {
    id: 10,
    name: '雾',
    ingredients: ['元酒2021 15ml', '白州1973威士忌 30ml', '冷泡糯香普洱茶 22.5ml', '檀木烟熏陈皮糖浆 7.5ml', '西柚苦精 2 dash'],
    method: 'stir',
    homemadeNote:
      '冷泡糯香普洱茶：5g糯香普洱茶用开水烫一遍打开后滤掉水分，加入500ml纯净水冷藏浸泡6小时，咖啡滤纸过滤装瓶，冷藏保存。檀木烟熏陈皮糖浆：25g新会陈皮用开水烫5分钟后去除白色软瓤，加入200g韩国黄糖、200ml纯净水放入锅中边搅拌边煮，煮沸后再继续煮3分钟关火，自然放凉后纱布过滤装入密封罐中，充入檀木烟雾，盖上盖子摇晃后静置一晚，隔天装瓶冷藏保存',
    author: 'Asher',
  },
  {
    id: 11,
    name: '露',
    ingredients: ['元酒Yuan 40ml', '话梅蜂蜜 15ml', '青柠汁 10ml', '干姜水 45ml', '甘草盐泡沫 top'],
    method: 'rolling',
    homemadeNote:
      '话梅蜂蜜：20颗咸话梅、200ml纯净水、50g蜂蜜小火边搅拌边煮，煮沸后再继续煮3分钟关火，自然放凉后咖啡滤纸过滤装瓶，冷藏保存。甘草盐泡沫：10g甘草盐、400ml纯净水搅拌融化后制成甘草盐水，装瓶冷藏保存，使用时取100ml甘草盐水加入2g大豆软凝脂，用发泡机制成泡沫状使用',
    author: 'Asher',
  },
  {
    id: 12,
    name: '与光同元',
    ingredients: ['元酒2021 45ml', '来炼香米栗子 20ml', '刚萨比亚斯奥罗素雪利酒 5ml', '龙眼蜜（1:1）10ml', '香草苦精 1 dash'],
    method: 'stir',
    homemadeNote: '龙眼蜜制法：天然龙眼蜜200g，100g纯净水（烧开）搅拌融合。装饰：orange slice',
    author: 'lay',
  },
  {
    id: 13,
    name: '元菠萝大吉利（又名绍兴以南，2026蔗园热带挑战赛东区冠军作品）',
    ingredients: ['元酒2021 45ml', '提基菠萝朗姆 20ml', '黄柠檬汁 20ml', '自制斑斓椰子糖浆 15ml', '蔗园椰子朗姆酒 2.5ml'],
    method: 'shake & double strain',
    homemadeNote:
      '斑斓叶子糖浆制法：100g斑斓叶洗净擦干剪成小段，与600g椰子水放入破壁机搅打；打碎后放入小电锅，500w功率加热至70度关火；用奶茶滤布滤出液体；滤出液体与500g白砂糖加入小电锅小火熬制，直至糖全部融化。注意：不宜加热超过60度导致水分蒸发，冷藏保存20天。装饰：pineapple slice（dry、roast）',
    author: 'lay',
  },
  {
    id: 14,
    name: '元高球',
    ingredients: ['元酒2021 45ml', '弗朗热带风情库拉索 15ml', '莫雷威廉梨利口酒 10ml', '苏打 top'],
    method: 'build',
    homemadeNote: '装饰：新鲜橙片',
    author: 'lay',
  },
  {
    id: 15,
    name: '青梅古典',
    ingredients: ['元酒2021 20ml', '三郎丸青梅威士忌 40ml', '方糖 一块', '安高天娜原味苦精 1 dash', '比特储斯桃子苦精 1 dash'],
    method: 'stir',
    homemadeNote: '古典杯咸话梅粉沿边，装饰青柠角',
    author: '大象',
  },
  {
    id: 16,
    name: '淦',
    ingredients: ['甘草柠檬元酒 50ml', '雪利酒 10ml', '红味美思（曼奇诺）15ml', '盐水 3 dash', '安高天娜原味苦精 2 dash'],
    method: 'stir',
    homemadeNote: '1瓶元2021，100g甘草柠檬切成丝，冷冻浸泡1天过滤，取酒液4/5',
    author: '曾曾',
  },
];

const RecipeCard: React.FC<{ recipe: RecipeItem }> = ({ recipe }) => {
  const [expanded, setExpanded] = useState(false);
  const hasHomemadeNote = (recipe?.homemadeNote ?? '').trim() !== '' && recipe?.homemadeNote !== '-';

  return (
    <div className="group flex h-full flex-col rounded-[22px] border border-white/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.03),rgba(255,255,255,0.015))] p-6 shadow-[0_18px_48px_rgba(0,0,0,0.28)] transition-all hover:-translate-y-1 hover:border-[#FFC000]/40 hover:shadow-[0_24px_60px_rgba(0,0,0,0.35)]">
      <div className="mb-5 flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="mb-3 inline-flex h-9 min-w-9 items-center justify-center rounded-full border border-[#FFC000]/30 bg-[#FFC000]/10 px-3 text-sm font-semibold text-[#FFC000]">
            {String(recipe?.id ?? '').padStart(2, '0')}
          </div>
          <div className="font-['Noto_Serif_SC','Songti_SC',serif] text-2xl leading-snug text-white">
            {recipe?.name ?? ''}
          </div>
        </div>
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#FFC000]/20 bg-[#FFC000]/8 text-[#FFC000]">
          <FlaskConical className="h-5 w-5" />
        </div>
      </div>

      <div className="mb-5 flex flex-wrap items-center gap-3 text-xs tracking-[0.18em] text-white/55">
        <div className="rounded-full border border-[#FFC000]/30 bg-[#FFC000]/10 px-3 py-1.5 text-[#FFC000]">
          出品方式 · {recipe?.method ?? ''}
        </div>
        <div className="rounded-full border border-white/10 px-3 py-1.5">
          作者 · {recipe?.author ?? ''}
        </div>
      </div>

      <div className="mb-4 text-xs tracking-[0.28em] text-[#FFC000]">材料配比</div>
      <div className="flex flex-1 flex-col gap-2.5">
        {(recipe?.ingredients ?? []).map((item) => (
          <div key={`${recipe?.id ?? 'recipe'}-${item}`} className="flex items-start gap-3 text-sm leading-7 text-white/78">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#FFC000]" />
            <span>{item}</span>
          </div>
        ))}
      </div>

      {hasHomemadeNote && (
        <div className="mt-6 rounded-[18px] border border-[#FFC000]/16 bg-black/25 px-4 py-4">
          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="flex w-full items-center justify-between gap-4 text-left text-sm text-[#FFC000] transition-opacity hover:opacity-90"
            aria-expanded={expanded}
          >
            <span className="tracking-[0.16em]">自制材料说明</span>
            {expanded ? <ChevronUp className="h-4 w-4 shrink-0" /> : <ChevronDown className="h-4 w-4 shrink-0" />}
          </button>
          {expanded && (
            <div className="mt-4 border-t border-white/10 pt-4 text-sm leading-7 text-white/72">
              {recipe?.homemadeNote ?? ''}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export const RecipeSection: React.FC = () => {
  return (
    <section id="recipes" className="bg-[#101010] px-5 py-24 md:px-10">
      <div className="mx-auto max-w-[1200px]">
        <div className="mb-14 max-w-3xl">
          <div className="mb-5 inline-block border border-[#FFC000]/60 px-4 py-1 text-[11px] tracking-[0.35em] text-[#FFC000]">
            基础配方
          </div>
          <h2 className="mb-5 font-['Noto_Serif_SC','Songti_SC',serif] text-4xl text-white md:text-5xl">
            16款合作鸡尾酒配方
          </h2>
          <div className="max-w-2xl text-base leading-8 text-white/72 md:text-lg">
            以元酒梦 2021 君系列为核心的基础创作配方，涵盖搅拌、摇和、兑和与加气表达，适用于酒吧共创、酒单开发与风味实验。
          </div>
        </div>

        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
          {recipes.map((recipe) => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecipeSection;
